import { translations, translate as translateHelper, pluralize as pluralizeHelper } from '@/locales/translations';

/**
 * Simple i18n Service
 * Manages application translations
 */
class I18nService {
  constructor() {
    // Get default locale from localStorage or use Arabic as default
    this.locale = localStorage.getItem('app_locale') || 'ar';
  }

  /**
   * Set the application locale
   * @param {string} locale - Language code (en, ar, etc.)
   */
  setLocale(locale) {
    this.locale = locale;
    localStorage.setItem('app_locale', locale);
  }

  /**
   * Get the current locale
   * @returns {string} Current locale
   */
  getLocale() {
    return this.locale;
  }

  /**
   * Translate a key with optional variables
   * @param {string} key - Translation key
   * @param {Object} variables - Variables to replace in the translation
   * @returns {string} Translated text
   */
  t(key, variables = {}) {
    return translateHelper(key, this.locale, variables);
  }

  /**
   * Get plural form based on count
   * @param {number} count - The count
   * @param {string} singular - Singular form
   * @param {string} plural - Plural form
   * @returns {string} Appropriate form
   */
  pluralize(count, singular, plural) {
    return pluralizeHelper(count, singular, plural);
  }

  /**
   * Get all available locales
   * @returns {Array} List of available locale codes
   */
  getAvailableLocales() {
    return Object.keys(translations);
  }

  /**
   * Check if a locale is available
   * @param {string} locale - Locale code to check
   * @returns {boolean} True if available
   */
  isLocaleAvailable(locale) {
    return translations.hasOwnProperty(locale);
  }
}

// Export singleton instance
export default new I18nService();

